/**
 * Filter option values for each enumerated employee field.
 * These are the raw database values — labels come from i18n via optionLabelPrefix.
 * Union types in employeeTypes.ts are derived from these arrays.
 */

export const EMPLOYEE_FIELD_CODES = [
  'AF_COO1', 'AF_HER1', 'BF_BOR1', 'BF_COO1', 'BJ_COO1', 'BJ_KAN1', 'BU_COO1', 'BU_KIR1',
  'CD_COO1', 'CD_GOM1', 'CF_BAN1', 'CF_COO1', 'CM_COO1', 'CM_MAK1', 'CO_COO1', 'CO_TIB1',
  'ET_AFA1', 'ET_COO1', 'KE_COO1', 'KE_DAD1', 'LB_COO1', 'LB_SAI1', 'MG_COO1', 'MG_TOL1',
  'ML_COO1', 'ML_NIO1', 'MM_COO1', 'MM_KAC1', 'MZ_COO1', 'MZ_MUE1', 'NE_COO1', 'NE_DIF1',
  'NG_COO1', 'NG_MAI1', 'PS_COO1', 'PS_NAB1', 'SD_COO1', 'SD_NYA1', 'SS_COO1', 'SS_MAL1',
  'SY_ALE1', 'SY_COO1', 'TD_BAG1', 'TD_COO1', 'VZ_AMA1', 'VZ_COO1', 'YE_COO1', 'YE_MAR1',
] as const;

export const EMPLOYEE_GENDERS = ['F', 'M'] as const;

export const EMPLOYEE_MARITAL_STATUSES = ['CE', 'DI', 'MA', 'VE'] as const;

export const EMPLOYEE_COUNTRIES = [
  'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AN', 'AO', 'AR', 'AS', 'AT', 'AU', 'AW', 'AZ',
  'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BM', 'BN', 'BO', 'BR', 'BS', 'BT',
  'BU', 'BW', 'BX', 'BY', 'BZ',
  'CA', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CY', 'CZ',
  'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ',
  'EC', 'EE', 'EG', 'ER', 'ES', 'ET',
  'FI', 'FJ', 'FK', 'FM', 'FO', 'FR',
  'GA', 'GB', 'GD', 'GE', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GT', 'GU', 'GW', 'GY',
  'HK', 'HN', 'HR', 'HT', 'HU',
  'ID', 'IE', 'IL', 'IN', 'IQ', 'IR', 'IS', 'IT',
  'JM', 'JO', 'JP',
  'KE', 'KG', 'KH', 'KI', 'KM', 'KP', 'KR', 'KW', 'KY', 'KZ',
  'LA', 'LB', 'LC', 'LI', 'LK', 'LO', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY',
  'MA', 'MC', 'MD', 'MG', 'ML', 'MM', 'MN', 'MO', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ',
  'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NS', 'NU', 'NZ',
  'OM',
  'PA', 'PE', 'PG', 'PH', 'PK', 'PL', 'PM', 'PR', 'PS', 'PT', 'PW', 'PY',
  'QA',
  'RE', 'RO', 'RU', 'RW',
  'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SY', 'SZ',
  'TC', 'TD', 'TG', 'TH', 'TJ', 'TK', 'TN', 'TO', 'TP', 'TR', 'TT', 'TV', 'TW', 'TY', 'TZ',
  'UA', 'UG', 'US', 'UY', 'UZ',
  'VA', 'VC', 'VE', 'VN', 'VU',
  'WS',
  'YE', 'YU',
  'ZA', 'ZM', 'ZW',
] as const;

export const EMPLOYEE_CONTRACT_CURRENTS = ['N', 'O'] as const;

export const EMPLOYEE_CONTRACT_CREATION_TYPES = ['AVENA', 'NEWCT', 'PROL'] as const;

export const EMPLOYEE_CONTRACT_TYPES = ['AUTRE', 'CDD', 'CDI', 'CREMPL', 'INCENT', 'PREST'] as const;

export const EMPLOYEE_CONTRACT_SALARY_SCALES = [
  'GS_CF_2017',
  'SS_UGANDA_2023',
] as const;

export const EMPLOYEE_CONTRACT_LEVELS = [
  '1', '2', '4', '5', '6', '7', '8', '9', '10', '11', '12',
] as const;

export const EMPLOYEE_JOB_FUNCTIONS = [
  'AGENTE', 'AGESUI', 'ANICOM',
  'ASSADM', 'ASSCDP', 'ASSFIN', 'ASSLOG', 'ASSMAJ', 'ASSPR1', 'ASSPR2', 'ASSRHU', 'ASSSAN', 'ASSSUI',
  'CAISSI', 'CHADEV', 'CHAFOR', 'CHASUI', 'CHAUFF', 'CHEAAP', 'CHEBUR', 'CHEPRO', 'CHESSB',
  'COOINF', 'COOPRO',
  'EXPJEU',
  'GARSAL', 'GESAUT', 'GUARDI',
  'INFTRA', 'INGCON',
  'LOGISTI',
  'MAGASI', 'MANADJ', 'MANAGE', 'MEDCHE', 'MEDCOO', 'MEDTRA', 'MEDTRC', 'MOBCOM', 'MONANI',
  'OFFPRO', 'OPERAD',
  'RAFIN1', 'RAFIN2', 'RESFIJ', 'RESFIS', 'RESRHU',
  'SECCAI', 'SECDIR', 'SUPERV',
  'TECSAN',
  'VERCOM', 'VERMED', 'VERSCO',
] as const;
